import { IQuestionModel } from '@care-portals/api-interfaces';

const options = [
  { key: '0', value: 'Not at all' },
  { key: '1', value: 'A little bit' },
  { key: '2', value: 'Moderately' },
  { key: '3', value: 'Quite a bit' },
  { key: '4', value: 'Extremely' }
];

const questions = [
  'Repeated, disturbing, and unwanted memories of the stressful experience?',
  'Repeated, disturbing dreams of the stressful experience?',
  'Suddenly feeling or acting as if the stressful experience were actually happening again (as if you were actually back there reliving it)?',
  'Feeling very upset when something reminded you of the stressful experience?',
  'Having strong physical reactions when something reminded you of the stressful experience (for example, heart pounding, trouble breathing, sweating)?',
  'Avoiding memories, thoughts, or feelings related to the stressful experience?',
  'Avoiding external reminders of the stressful experience (for example, people, places, conversations, activities, objects, or situations)?',
  'Trouble remembering important parts of the stressful experience?',
  'Having strong negative beliefs about yourself, other people, or the world (for example, having thoughts such as: I am bad, there is something seriously wrong with me, no one can be trusted, the world is completely dangerous)?',
  'Blaming yourself or someone else for the stressful experience or what happened after it?',
  'Having strong negative feelings such as fear, horror, anger, guilt, or shame?',
  'Loss of interest in activities that you used to enjoy?',
  'Feeling distant or cut off from other people?',
  'Trouble experiencing positive feelings (for example, being unable to feel happiness or have loving feelings for people close to you)?',
  'Irritable behavior, angry outbursts, or acting aggressively?',
  'Taking too many risks or doing things that could cause you harm?',
  'Being “superalert” or watchful or on guard?',
  'Feeling jumpy or easily startled?',
  'Having difficulty concentrating?',
  'Trouble falling or staying asleep?',
];

const questionsModels: IQuestionModel[] = [
  {
    field: 'pcl5_intro',
    type: 'info',
    label:
      'Below is a list of problems that people sometimes have in response to a very stressful experience. Please read each problem carefully and then circle one of the answers to indicate how much you have been bothered by that problem in the past month.',
    answer: {}
  },
  ...questions.map(
    (q, i) =>
      ({
        field: `pcl5_${i + 1}`,
        label: q,
        type: 'select',
        answer: {
          type: 'single_select',
          options
        }
      } as IQuestionModel)
  )
];

export default questionsModels;
